export class JungleAudio {
    context?: AudioContext;
    master?: GainNode;
    ambience?: AudioBufferSourceNode;
    private wind?: BiquadFilterNode;
    private nextBird = 0;
    constructor(private volume: () => number) { }
    async start() { if (!this.context) {
        const c = new AudioContext();
        this.context = c;
        this.master = c.createGain();
        this.master.gain.value = this.volume();
        this.master.connect(c.destination);
        const buffer = c.createBuffer(1, c.sampleRate * 3, c.sampleRate), d = buffer.getChannelData(0);
        let last = 0;
        for (let i = 0; i < d.length; i++) {
            last = (last + (Math.random() * 2 - 1) * .015) / 1.015;
            d[i] = last * .16;
        }
        const noise = c.createBufferSource();
        noise.buffer = buffer;
        noise.loop = true;
        const low = c.createBiquadFilter();
        low.type = 'lowpass';
        low.frequency.value = 700;
        noise.connect(low);
        low.connect(this.master);
        noise.start();
        this.ambience = noise;
        this.wind = low;
    } await this.context.resume(); }
    play(kind: 'fruit' | 'grab' | 'jump' | 'discover' | 'finish' | 'splash' | 'crack') { if (!this.context || !this.master)
        return; const c = this.context;
    if (kind === 'crack') {
        // Dry snap: a short burst of filtered noise with a falling woody knock.
        const t = c.currentTime, buffer = c.createBuffer(1, Math.floor(c.sampleRate * .18), c.sampleRate), d = buffer.getChannelData(0);
        for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length) ** 3;
        const src = c.createBufferSource(), band = c.createBiquadFilter(), g = c.createGain();
        src.buffer = buffer; band.type = 'bandpass'; band.frequency.value = 1800; band.Q.value = .8;
        g.gain.setValueAtTime(.32, t); g.gain.exponentialRampToValueAtTime(.0001, t + .18);
        src.connect(band); band.connect(g); g.connect(this.master); src.start(t);
        const o = c.createOscillator(), og = c.createGain();
        o.type = 'triangle'; o.frequency.setValueAtTime(230, t); o.frequency.exponentialRampToValueAtTime(90, t + .12);
        og.gain.setValueAtTime(.12, t); og.gain.exponentialRampToValueAtTime(.0001, t + .14);
        o.connect(og); og.connect(this.master); o.start(t); o.stop(t + .15);
        return;
    }
    const notes = kind === 'finish' ? [523, 659, 784, 1047] : kind === 'discover' ? [440, 587, 740] : kind === 'fruit' ? [880, 1175] : kind === 'grab' ? [150] : kind === 'jump' ? [320, 510] : [120, 75]; notes.forEach((hz, i) => { const o = c.createOscillator(), g = c.createGain(), t = c.currentTime + i * .095; o.type = kind === 'grab' ? 'triangle' : 'sine'; o.frequency.setValueAtTime(hz, t); o.frequency.exponentialRampToValueAtTime(hz * 1.12, t + .15); g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.1, t + .01); g.gain.exponentialRampToValueAtTime(.0001, t + .25); o.connect(g); g.connect(this.master!); o.start(t); o.stop(t + .27); }); }
    update(time: number, speed: number) { if (!this.context || !this.master)
        return; this.master.gain.setTargetAtTime(this.volume(), this.context.currentTime, .1); this.wind?.frequency.setTargetAtTime(500 + speed * 80, this.context.currentTime, .5); if (time > this.nextBird) {
        this.nextBird = time + 4 + Math.random() * 8;
        const c = this.context, o = c.createOscillator(), g = c.createGain(), t = c.currentTime;
        o.frequency.setValueAtTime(1700 + Math.random() * 700, t);
        o.frequency.exponentialRampToValueAtTime(3200, t + .13);
        o.frequency.exponentialRampToValueAtTime(1800, t + .3);
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(.014, t + .04);
        g.gain.linearRampToValueAtTime(0, t + .35);
        o.connect(g);
        g.connect(this.master);
        o.start();
        o.stop(t + .36);
    } }
}
